module.exports = __webpack_public_path__ + "img/27_80.6cc24f85.png";